import CursSuccessPage from './curs-success-page';

export default CursSuccessPage;
